import { get } from 'lodash';
import { useFindRecord } from 'api/APIHooks';

const useAuthorizationWithLineage = (serviceAuthorization) => {
  const queryResult = useFindRecord(
    'service_authorization',
    serviceAuthorization.id,
    {
      customParams: {
        include: 'lineage',
      },
      queryConfig: {
        enabled: !!serviceAuthorization.id,
        placeholderData: undefined,
      },
    },
  );

  const { data: authWithLineageData, isSuccess } = queryResult;
  const authWithLineage = get(authWithLineageData, 'data.data', serviceAuthorization);
  const lineageData = get(authWithLineage, 'lineage', []);

  const lineageAuthorizations = lineageData;

  return {
    currentAuthorization: authWithLineage,
    lineageAuthorizations,
    isSuccess,
    queryData: authWithLineageData,
  };
};

export default useAuthorizationWithLineage;
